import React from 'react';
import { Platform, TouchableOpacity, View } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';
import { useNavigation } from '@react-navigation/native';

import { Header } from '../index';
import { Typography } from '../ui';
import { useTheme } from '../../context/ThemeContext';

import { ON_ACCENT_TEXT } from '../../styles/accentText';
/**
 * CORE-1186 — что видно вместо денежного раздела, пока `finance_screen` выключен.
 *
 * Прятать пункт в шапке недостаточно: `/finance`, `/wallet` и
 * `/fund/payout-details` открываются из закладки, письма и поисковой выдачи при
 * любом состоянии флагов, а последний ещё и принимает ИНН/СНИЛС. Поэтому гейт
 * стоит на самих экранах, а не только в навигации.
 *
 * Не редирект: адрес человек открыл осознанно, и молча увести его на главную —
 * значит не ответить на вопрос «а где раздел». Здесь ответ есть, и выход тоже.
 */
export const FinanceUnavailable: React.FC = () => {
  const { colors: C } = useTheme();
  const nav = useNavigation<any>();

  return (
    <View style={{ flex: 1, backgroundColor: C.pageBg }}>
      <Header />
      <View
        style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24, gap: 12 }}
        testID="finance-unavailable"
      >
        <Ionicons name="wallet-outline" size={40} color={C.textMuted} />
        <Typography variant="h3" style={{ color: C.textPrimary, textAlign: 'center' }}>
          Раздел пока закрыт
        </Typography>
        <Typography
          variant="bodySmall"
          style={{ color: C.textSecondary, textAlign: 'center', maxWidth: 420 }}
        >
          Финансы откроются вместе с оплатой. Подписки, покупки и выплаты появятся здесь, когда их
          можно будет провести по-настоящему.
        </Typography>
        <TouchableOpacity
          accessibilityRole="button"
          onPress={() => nav.navigate('Home')}
          style={{
            marginTop: 8,
            paddingHorizontal: 22,
            paddingVertical: 12,
            borderRadius: 999,
            backgroundColor: C.solar,
            ...(Platform.OS === 'web' ? ({ cursor: 'pointer' } as any) : null),
          }}
        >
          <Typography variant="button" style={{ color: ON_ACCENT_TEXT }}>На главную</Typography>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default FinanceUnavailable;
